/**
 * @fileoverview gRPC-Web generated client stub for adx.consultant_report
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.adx = {};
proto.adx.consultant_report = require('./consultant_report_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.consultant_report.ConsultantReportClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.consultant_report.ConsultantReportPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest,
 *   !proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse>}
 */
const methodDescriptor_ConsultantReport_GetConsultantCategoryMonthlyReport = new grpc.web.MethodDescriptor(
  '/adx.consultant_report.ConsultantReport/GetConsultantCategoryMonthlyReport',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest,
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse,
  /**
   * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.deserializeBinary
);


/**
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.consultant_report.ConsultantReportClient.prototype.getConsultantCategoryMonthlyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.consultant_report.ConsultantReport/GetConsultantCategoryMonthlyReport',
      request,
      metadata || {},
      methodDescriptor_ConsultantReport_GetConsultantCategoryMonthlyReport);
};


/**
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.consultant_report.ConsultantReportPromiseClient.prototype.getConsultantCategoryMonthlyReport =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.consultant_report.ConsultantReport/GetConsultantCategoryMonthlyReport',
      request,
      metadata || {},
      methodDescriptor_ConsultantReport_GetConsultantCategoryMonthlyReport);
};


module.exports = proto.adx.consultant_report;

